var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { grow: "" } },
    [
      _c(
        "w-col",
        { attrs: { md: "12", xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("titles.extra-info"))),
              ]),
              _c(
                "w-card-content",
                [
                  _vm.showEditor
                    ? _c("w-editor", {
                        attrs: { height: "400", value: _vm.text },
                        on: {
                          input: function ($event) {
                            return _vm.onInput($event)
                          },
                          "cursor-position": function ($event) {
                            return _vm.$emit("cursor-position", $event)
                          },
                        },
                      })
                    : _c("w-textarea-autogrow", {
                        attrs: {
                          "max-height": 500,
                          fancy: "",
                          label: _vm.$ct("labels.extra-info"),
                        },
                        model: {
                          value: _vm.contact.Info,
                          callback: function ($$v) {
                            _vm.$set(_vm.contact, "Info", $$v)
                          },
                          expression: "contact.Info",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }